export default {
  main: '#EC629E',
  secondary: '#F9AE53',
  contrastingColor: '#000000',
  priceColor: '#E1235F',
  entryBackground: '#A7C6D8',
  menuBackgroundColor: '#A7C6D8',
  menuTextColor: '#ffffff',
};
